import React from 'react';

const CampaignMarquee = ({ items }) => (
  <div className="hhc-mq-bar" aria-hidden="true">
    <div className="hhc-mq-track">
      {items.map((item, index) => (
        <span key={`${item}-${index}`}>{item}</span>
      ))}
    </div>
  </div>
);

export default CampaignMarquee;
